import { createContext, useContext, useState } from "react"

const StoreContext = createContext()

export const StoreProvider = ({ children }) => {
  const [storeId, setStoreId] = useState(null)

  const [storeData, setStoreData] = useState(null)

  return (
    <StoreContext.Provider value={{ storeId, setStoreId, storeData, setStoreData }}>
      {children}
    </StoreContext.Provider>
  )
}

export const useStore = () => useContext(StoreContext)


